import { useState } from 'react';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href="https://wa.me/19046087529?text=Hola%2C%20me%20gustar%C3%ADa%20obtener%20informaci%C3%B3n%20sobre%20sus%20servicios%20de%20limpieza."
      target="_blank"
      rel="nofollow noreferrer"
      aria-label="Contactar por WhatsApp"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 cursor-pointer group"
    >
      {/* Tooltip */}
      <span
        className={`
          bg-white text-gray-800 text-sm font-medium px-3 py-2 rounded-lg shadow-md
          whitespace-nowrap transition-all duration-300 pointer-events-none
          ${hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2'}
        `}
      >
        ¡Escríbenos ahora!
      </span>

      {/* Button */}
      <div className="relative w-14 h-14 flex items-center justify-center">
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-green-400 opacity-30 animate-ping" />
        <div className="relative w-14 h-14 flex items-center justify-center bg-green-500 hover:bg-green-400 rounded-full transition-colors duration-200 shadow-lg">
          <i className="ri-whatsapp-line text-white text-2xl"></i>
        </div>
      </div>
    </a>
  );
}
